export let dataProps = {
    id: 0,
    team_name: '',
    additional_notes: '',
    profile_photo: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/teamCategory/properties.js